module.exports = __webpack_public_path__ + "static/media/Sharp-Technology-R-IGZO-3.3e754c5b.png";